import { confirmEmailSendSuccess } from '../content/notifications'

export const UPDATE_SCREEN_DIMENTIONS = 'UPDATE_SCREEN_DIMENTIONS'
export const SET_SIDEBAR_THEME = 'SET_SIDEBAR_THEME'
export const SET_BODYLESS_SIDEBAR = 'SET_BODYLESS_SIDEBAR'
export const SET_LOGOLESS_SIDEBAR = 'SET_LOGOLESS_SIDEBAR'


export const POST_BRIEF_FORM_REQUEST = 'POST_BRIEF_FORM_REQUEST'
export const POST_BRIEF_FORM_SUCCESS = 'POST_BRIEF_FORM_SUCCESS'
export const POST_BRIEF_FORM_FAIL = 'POST_BRIEF_FORM_FAIL'

export const POST_JOIN_FORM_REQUEST = 'POST_JOIN_FORM_REQUEST'
export const POST_JOIN_FORM_SUCCESS = 'POST_JOIN_FORM_SUCCESS'
export const POST_JOIN_FORM_FAIL = 'POST_JOIN_FORM_FAIL'

export const TOGGLE_FORM_NOTIFICATION = 'TOGGLE_FORM_NOTIFICATION'

export const updateScreenDimentions = payload => ({
  type: UPDATE_SCREEN_DIMENTIONS,
  payload
})

export const setSidebarTheme = payload => ({
  type: SET_SIDEBAR_THEME,
  payload
})

export const toggleBodylessSidebar = payload => ({
  type: SET_BODYLESS_SIDEBAR,
  payload
})

export const toggleLogolessSidebar = payload => ({
  type: SET_LOGOLESS_SIDEBAR,
  payload
})


export const postBriefForm = payload => ({
  type: POST_BRIEF_FORM_REQUEST,
  payload
})

export const postBriefFormSuccess = result => ({
  type: POST_BRIEF_FORM_SUCCESS,
  payload: result
})

export const postBriefFormFailed = error => ({
  type: POST_BRIEF_FORM_FAIL,
  payload: error
})

export const postJoinForm = payload => ({
  type: POST_JOIN_FORM_REQUEST,
  payload
})

export const postJoinFormSuccess = result => ({
  type: POST_JOIN_FORM_SUCCESS,
  payload: result
})

export const postJoinFormFailed = error => ({
  type: POST_JOIN_FORM_FAIL,
  payload: error
})

export const toggleFormNotification = () => ({
  type: TOGGLE_FORM_NOTIFICATION
})

const initialState = {
  screenSize: {
    width: 1024,
    height: 768
  },
  isDarkTheme: false,
  isNavBody: true,
  isLogoBody: true,
  form: {
    success: false,
    fetching: false,
    showNotification: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SCREEN_DIMENTIONS:
      return {
        ...state,
        screenSize: { ...action.payload }
      }
    case SET_SIDEBAR_THEME: {
      return {
        ...state,
        isDarkTheme: action.payload
      }
    }
    case SET_BODYLESS_SIDEBAR: {
      return {
        ...state,
        isNavBody: action.payload
      }
    }
    case SET_LOGOLESS_SIDEBAR: {
      return {
        ...state,
        isLogoBody: action.payload
      }
    }
    case POST_BRIEF_FORM_REQUEST:
      return {
        ...state,
        form: {
          fetching: true,
          success: false,
          showNotification: false,
          message: ''
        }
      }
    case POST_BRIEF_FORM_SUCCESS:
      return {
        ...state,
        form: {
          fetching: false,
          success: true,
          showNotification: true,
          message: confirmEmailSendSuccess
        }
      }
    case POST_BRIEF_FORM_FAIL:
      return {
        ...state,
        form: {
          fetching: false,
          success: false,
          notification: false
        }
      }
    case POST_JOIN_FORM_REQUEST:
      return {
        ...state,
        form: {
          fetching: true,
          success: false,
          notification: false
        }
      }
    case POST_JOIN_FORM_SUCCESS:
      return {
        ...state,
        form: {
          fetching: false,
          success: true,
          showNotification: true,
          message: confirmEmailSendSuccess
        }
      }
    case POST_JOIN_FORM_FAIL:
      return {
        ...state,
        form: {
          fetching: false,
          success: false,
          notification: false
        }
      }
    case TOGGLE_FORM_NOTIFICATION:
      return {
        ...state,
        form: {
          ...state.form,
          showNotification: !state.form.showNotification,
          success: false,
          message: ''
        }
      }

    default:
      return state
  }
}

// SELECTORS

export default reducer
